import { format } from 'date-fns';
import { Pages } from 'modules/navigation/domain/enums/pages';
import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AppDispatch } from 'store/store';
import { UDImage } from 'ud-ui/components';
import Modal from 'ud-ui/components/modal';
import UDButton from 'ud-ui/components/button';
import UDText from 'ud-ui/components/text';
import { Player, Team } from 'modules/players/domain/interfaces/player';
import { kickTournamentUserFromTeam } from 'modules/players/store/actions';

interface IProps {
  index: number;
  team: Team;
  player: Player;
}

function TeamCard(props: IProps) {
  const { team, index, player } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const open = useCallback(() => setIsModalOpen(true), []);
  const close = useCallback(() => setIsModalOpen(false), []);

  const handleClickTeam = useCallback(() => {
    navigate(Pages.TEAMS.builders.edit(team.id), { state: { fromPlayer: player.id } });
  }, [navigate, player.id, team.id]);

  const handleKickFromTeam = useCallback(() => {
    dispatch(kickTournamentUserFromTeam({ userId: player.id, teamId: team.id })).then(() => {
      toast.success('Игрок исключен из команды');
    });
  }, [dispatch, player.id, team.id]);

  return (
    <>
      <div className={'bordered-block flex h-18 items-center p-4'}>
        <div className={'flex w-1/3 items-center'}>
          {index !== undefined && (
            <UDText type="subhead" className="bold flex min-w-8 justify-center">
              {index + 1}
            </UDText>
          )}

          <div className="flex min-w-0 items-center gap-2">
            <UDImage url={team.emblem?.externalUrl} />
            <UDText type="subhead" className="bold truncate">
              {team.name}
            </UDText>
          </div>
        </div>

        <div className={'flex w-1/3 items-center justify-center'}>
          <UDText type="subhead">{format(new Date(team.createdAt), 'dd.MM.yyyy')}</UDText>
        </div>

        <div className={'flex w-1/3 items-center justify-end gap-2'}>
          <UDButton className="flex items-center" variant="primary" onClick={handleClickTeam}>
            <span>Редактировать</span>
          </UDButton>

          <UDButton className="flex items-center" variant="secondary" onClick={open}>
            <span>Исключить</span>
          </UDButton>
        </div>
      </div>

      <Modal show={isModalOpen} onClose={close}>
        <Modal.Body>
          <UDText type="headline" className="text-surfaceRomanSilver30 px-10" style={{ textAlign: 'center' }}>
            Вы действительно хотите исключить игрока
          </UDText>
          <UDText type="headline" className="text-surfaceRomanSilver30 px-10" style={{ textAlign: 'center' }}>
            {player.name} {player.surname} {player.middleName ?? ''}
          </UDText>
          <UDText type="headline" className="text-surfaceRomanSilver30 mb-15 px-10" style={{ textAlign: 'center' }}>
            из {team.name}?
          </UDText>
        </Modal.Body>
        <Modal.Footer>
          <UDButton
            className="mb-3 flex items-center justify-center"
            variant="primary"
            onClick={(e) => {
              close();
            }}
            stretch
          >
            <span>Нет</span>
          </UDButton>
          <UDButton
            className="mb-3 flex items-center justify-center"
            variant="primary"
            onClick={(e) => {
              handleKickFromTeam();
            }}
            stretch
          >
            <span>Да</span>
          </UDButton>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default TeamCard;
